import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthSessionContext } from "../contexts/AuthSessionContext";

type UserRoleGateProps = {
  allowedRoles: string[];
  children: React.ReactNode;
};

const UserRoleGate: React.FC<UserRoleGateProps> = ({ allowedRoles, children }) => {
  const authContext = useContext(AuthSessionContext);
  
  if (!authContext) {
    return <Navigate to="/login" replace />;
  }
  
  const { session, userRole } = authContext;

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  if (!userRole || !allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default UserRoleGate;



